export const COLOR_CONSTANTS = {
  PRIMARY: "#EA6D66",
  WHITE: "#fff",
  DARK: "black",
  LINE_ORANGE: "#EF865F",
  LINE_BLUE: "#5BC4DE",
  LINE_RED: "#FF4433",
  LIGHT_ORANGE: "#FCEFEB",
  LIGHT_BLUE: "#EAF8FB",
  LIGHT_RED: "#FBEFF3",
  HEART_BEAT: "#CA6B6E",
  TEMPERATURE: "#8997CE",
  RESPIRATION: "#F56C86",
  HEIGHT: "#E6CD8D",
  WEIGHT: "#D8A3C9",
  O2_SATURATION: "#8BABFE",
  PAIN: "#F78938",
  GREEN: "#008000",
};
